import * as S from './styles';
import { Label } from '../../../Basic/Label/label';

interface InputTitleProps {
    form?: boolean | (null | undefined),
    label: string | (null | undefined),
    htmlFor?: string | undefined,
    fontSize?: string;
}

export function InputTitle(props: InputTitleProps){

    return (
        props.label &&
        (
            props.form ?
                <S.InputLabel htmlFor={props.htmlFor} fontSize={props.fontSize}>{props.label}</S.InputLabel>
                :
                <Label htmlFor={props.htmlFor}>{props.label}</Label>
        )
    )
}
